<div class="main-content">
    <div class="container-fluid p-1">
        <div class="card">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card-header card-header-tabs p-1 card-header-oportunidad"
                        [ngClass]="[datosOportunidad.estado]">
                        <div class="row align-items-center">
                            <div class="col-lg-9 col-md-8 col-sm-12">
                                <h3 class="card-title ml-2">
                                    {{datosOportunidad.idProyecto}} : {{datosOportunidad.nombre}}
                                </h3>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-12 text-end">
                                <button type="button" class="btn btn-sm" [ngClass]="[datosOportunidad.estado]"
                                    matTooltip="Regresar a inicio" (click)="regresar()">
                                    <i class="fa fa-undo"></i><span
                                        class="text-decoration-underline ml-1">Regresar</span></button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body pt-0 pr-0">
                <div class="row">
                    <div class="col-lg-3 col-md-4 col-sm-12  mt-2 card mb-0">
                        <div class="card-body p-0" style="min-height: 353px; ">
                            <div class="mt-1 w-100 color-oportunidad-default" style="height:3px;"
                                [ngClass]="[datosOportunidad.estado]"></div>
                            <table class="table">
                                <thead class="cdk-visually-hidden"><tr><th scope="col">Datos de la oportunidad</th></tr></thead>
                                <tbody>
                                    <tr>
                                        <td class="pb-1 h6">
                                            <h6 class="mb-0"> Cliente:</h6>
                                            <p class="fw-bold">{{datosOportunidad.nombreCliente}}</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="pb-1 h6">
                                            <h6 class="mb-0"> Estatus:</h6>
                                            <span class="tag-estatus-oportunidad"
                                                [ngClass]="[datosOportunidad.estado]">{{datosOportunidad.estatus}}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="pb-0 h6">
                                            <h6 class="mb-0"> Fecha de creación:</h6>
                                            <p class="fw-bold"> {{datosOportunidad.fechaCreacion | date: 'd MMM y,
                                                HH:mm'}}</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="pb-0 h6">
                                            <h6 class="mb-0"> Fecha de actualización:</h6>
                                            <p class="fw-bold">{{datosOportunidad.fechaActualizacion | date: 'd MMM y,
                                                HH:mm'}}</p>
                                        </td>
                                    </tr>
                                    <tr *ngIf='datosOportunidad.fechaEstimacion !== null'>
                                        <td class="pb-0 h6 ">
                                            <h6 class="mb-0">Fecha de estimación:</h6>
                                            <p class="fw-bold">{{datosOportunidad.fechaEstimacion | date: 'd MMM y,
                                                HH:mm'}}</p>
                                        </td>
                                    </tr>

                                    <tr *ngIf='datosOportunidad.descripcion !== null'>
                                        <td class="pb-0 h6">
                                            <h6 class="h6 mb-0">Descripción:</h6>
                                            <p class="text-justify fw-bold"> {{datosOportunidad.descripcion}}</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-lg-9 col-md-8 col-sm-12">
                        <div class="row">

                            <div class="col-sm-12">
                                <div class="card mb-0">
                                    <div class="card-header card-header-tabs p-1 card-header-oportunidad"
                                        [ngClass]="[datosOportunidad.estado]">
                                        <div class="nav-tabs-navigation">
                                            <div class="nav-tabs-wrapper">
                                                <ul class="nav nav-tabs" data-tabs="tabs">
                                                    <li class="nav-item">
                                                        <a class="nav-link active" href="#comentarioProyecto"
                                                            data-toggle="tab">
                                                            <i class="fa fa-comment"></i> Comentarios
                                                            <div class="ripple-container"></div>
                                                        </a>
                                                    </li>

                                                    <li class="nav-item"
                                                        *ngIf='datosOportunidad.colaboradores != null && datosOportunidad.colaboradores.length > 0'>
                                                        <a class="nav-link" href="#equipoTrabajo" data-toggle="tab">
                                                            <i class="material-icons">groups</i> Equipo de Trabajo
                                                            <div class="ripple-container"></div>
                                                        </a>
                                                    </li>
                                                    <li class="nav-item">
                                                        <a class="nav-link" href="#estimiacion" data-toggle="tab">
                                                            <i class="fa fa-calendar"></i> Estimaci&oacute;n
                                                            <div class="ripple-container"></div>
                                                        </a>
                                                    </li>
                                                    <li class="nav-item" *ngIf="listaArchivosGralGuardada.length > 0">
                                                        <a class="nav-link" href="#archivosGrales" data-toggle="tab">
                                                            <i class="fa fa-folder-open"></i> archivos
                                                            <div class="ripple-container"></div>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body pt-1">
                                        <div class="tab-content"
                                            style="max-height: 410px; min-height: 321px; overflow: auto;">
                                            <div class="tab-pane active" id="comentarioProyecto">


                                                <div class="col-md-12">
                                                    <ul class="timeline timeline-simple mt-0"
                                                        *ngIf=" listaComentarios.length > 0">
                                                        <li class="timeline-inverted"
                                                            *ngFor="let comentarioOportunidad of listaComentarios">
                                                            <div class="timeline-badge"
                                                                [ngClass]="comentarioOportunidad.estado"><i
                                                                    class="material-icons">{{
                                                                    estatusEnum.getIcoEstatus(comentarioOportunidad.estado)
                                                                    }}</i>
                                                                <h6 class="lh-sm"> <b>{{ comentarioOportunidad.estatus
                                                                        }} </b> </h6>
                                                            </div>
                                                            <div class="timeline-panel">
                                                                <div class="timeline-body">
                                                                    <p>{{ comentarioOportunidad.contenido }}</p>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-md-8">
                                                                        <h6>
                                                                            <b>{{ comentarioOportunidad.nombreUsuario
                                                                                }}</b>&nbsp;&nbsp;&nbsp;
                                                                            {{ comentarioOportunidad.fecha | date:
                                                                            'EEEE, d MMMM, y, h:mm ' }}
                                                                        </h6>

                                                                    </div>
                                                                    <div class="col-md-4"
                                                                        *ngIf="comentarioOportunidad.archivosComentarios.length  > 0">
                                                                        <div class="dropdown pull-left">
                                                                            <button mat-raised-button type="button"
                                                                                class="btn btn-round btn-secondary dropdown-toggle "
                                                                                data-toggle="dropdown">

                                                                                <i
                                                                                    class="material-icons">attach_file</i>Adjuntos
                                                                                <span class="caret"></span>
                                                                            </button>
                                                                            <ul
                                                                                class="dropdown-menu dropdown-menu-right">
                                                                                <li
                                                                                    *ngFor="let evidencias of comentarioOportunidad.archivosComentarios;  let i = index">
                                                                                    <div class="row">
                                                                                        <div class="col-md-8 col-sm-12">
                                                                                            <h6
                                                                                                matTooltip="{{evidencias.name}}">
                                                                                                {{ evidencias.name }} {{
                                                                                                i + 1 }}</h6>
                                                                                        </div>
                                                                                        <div class="col-md-2 col-sm-6">
                                                                                            <button mat-raised-button
                                                                                                class="btn btn-just-icon btn-link "
                                                                                                *ngIf="evidencias.type != ''"
                                                                                                (click)="consultarArchivoComentario(evidencias)">
                                                                                                <i
                                                                                                    class="material-icons ">visibility</i>
                                                                                            </button>
                                                                                        </div>
                                                                                        <div class="col-md-2  col-sm-6">

                                                                                            <button mat-raised-button
                                                                                                class="btn btn-just-icon btn-link "
                                                                                                (click)="descargaEvidenciaComentario(evidencias)">
                                                                                                <i
                                                                                                    class="material-icons ">cloud_download</i>
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>




                                            <div class="tab-pane" id="equipoTrabajo"
                                                *ngIf="datosOportunidad.id_lider !== null || (datosOportunidad.colaboradores != null && datosOportunidad.colaboradores.length > 0)">
                                                <mat-list>
                                                    <span class="h6 fw-bold">Lider asignado</span>
                                                    <mat-list-item *ngIf="datosOportunidad.id_lider !== null"
                                                        style="height: 60px;">
                                                        <mat-icon matListItemIcon>assignment_ind</mat-icon>
                                                        <div matListItemTitle>{{datosOportunidad.nombreLider}}</div>
                                                    </mat-list-item>
                                                    <span class="h6 fw-bold">Colaboradores</span>
                                                    <mat-list-item *ngFor="let colab of datosOportunidad.colaboradores"
                                                        style="height: 60px;">
                                                        <mat-icon matListItemIcon>account_circle</mat-icon>
                                                        <div matListItemTitle>{{colab.persona.nombreCompleto}}</div>
                                                        <div matListItemLine> {{colab.puesto.puesto}} </div>
                                                    </mat-list-item>
                                                </mat-list>


                                            </div>

                                            <div class="tab-pane " id="estimiacion">
                                                <div>
                                                    <div
                                                        class="card-header card-header-tabs card-header-warning m-0 pt-0 pb-0">
                                                        <div class="nav-tabs-navigation">
                                                            <div class="nav-tabs-wrapper">
                                                                <span class="nav-tabs-title fw-bold h6"> <span> Cargar
                                                                        estimación :</span> </span>
                                                                <ul class="nav nav-tabs" data-tabs="tabs">
                                                                    <li class="nav-item" style="cursor: pointer;">
                                                                        <button class=" btn-file nav-link"
                                                                            style="cursor: pointer;"
                                                                            matTooltip="Formatos válidos: FDS-0, FMD-0">
                                                                            <a style="cursor: pointer;"><i
                                                                                    class="material-icons">upload_file
                                                                                </i> Agregar </a>
                                                                            <input aria-label="Agregar" type="file" id="nameFileEstimacion"
                                                                                accept=".pdf,.xls,.xlsx,.xlsm,.doc,.docx,.ppt,.pptx,"
                                                                                mozdirectory directory multiple
                                                                                (change)='cargarEstimacion()' />
                                                                        </button>
                                                                        <div class="ripple-container"></div>
                                                                    </li>
                                                                    <li class="nav-item" style="cursor: pointer;"
                                                                        *ngIf="listaEstimacionAgregarSelect.length>0">
                                                                        <button class="nav-link"
                                                                            (click)="removerEstimacion()">
                                                                            <a> <i
                                                                                    class="material-icons">delete_forever</i>
                                                                                Remover</a>
                                                                        </button>
                                                                        <div class="ripple-container"></div>
                                                                    </li>
                                                                </ul>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div class="border" *ngIf="listaEstimacionAgregar.length>0">
                                                        <mat-selection-list [(ngModel)]="listaEstimacionAgregarSelect"
                                                            (ngModelChange)="onNgModelChangeEstimacion($event)"
                                                            [ngModelOptions]="{standalone: true}">
                                                            <mat-list-option
                                                                *ngFor="let item of listaEstimacionAgregar; index as i"
                                                                [value]="item" class="text-muted">
                                                                <p class="text-muted">{{item.name}} </p>
                                                            </mat-list-option>
                                                        </mat-selection-list>
                                                    </div>
                                                </div>
                                                <div class="table-responsive "
                                                    *ngIf="listaEstimacionGuardada.length > 0">
                                                    <table class="table table-shopping table-striped table-no-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th class="text-muted fw-bold border-bottom primary"
                                                                    colspan="2"><span> Estimaciones</span></th>
                                                                <th class="text-center  fw-bold text-muted"> Fecha </th>
                                                                <th class="text-center text-muted fw-bold border-bottom primary"
                                                                    colspan="1">Acciones</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                *ngFor="let archivoEstimacion of listaEstimacionGuardada; let i = index">
                                                                <td class="pt-0 pb-0"
                                                                    matTooltip="{{archivoEstimacion.name}}" colspan="2">
                                                                    <img class="img" alt="icono archivo" height="34px"
                                                                        [src]="obtenerImagenTipoArchivo(archivoEstimacion.type)">
                                                                    {{ archivoEstimacion.name }}
                                                                </td>
                                                                <td class="text-center pt-0 pb-0 "
                                                                    matTooltip="Fecha de actualización">
                                                                    {{
                                                                    archivoEstimacion.fecha==null?'':archivoEstimacion.fecha|
                                                                    date: 'dd/MM/y, HH:mm' }}
                                                                </td>
                                                                <td class="text-center pt-0 pb-0" colspan="1">
                                                                    <button mat-raised-button
                                                                        class="btn btn-just-icon btn-link  btn-icon-accions-file"
                                                                        (click)="consultarArchivoEstimacion(datosOportunidad.idGit, archivoEstimacion.name, archivoEstimacion.type)"
                                                                        matTooltip="Ver archivo">
                                                                        <i class="material-icons">visibility</i>
                                                                    </button>
                                                                    <button mat-raised-button
                                                                        class="btn btn-just-icon btn-link  btn-icon-accions-file"
                                                                        (click)="descargaEvidencia(datosOportunidad.idGit, archivoEstimacion.name, archivoEstimacion.type)"
                                                                        matTooltip="Descargar archivo">
                                                                        <i class="material-icons">cloud_download</i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>

                                            <div class="tab-pane " id="archivosGrales"
                                                *ngIf="listaArchivosGralGuardada.length > 0  ">

                                                <div class="table-responsive ">
                                                    <table class="table table-shopping table-striped table-no-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th class="fw-bold text-muted border-bottom primary"
                                                                    colspan="2"> Archivo </th>
                                                                <th
                                                                    class="text-center  fw-bold text-muted border-bottom primary">
                                                                    Fecha </th>
                                                                <th class="text-center text-muted fw-bold border-bottom primary"
                                                                    colspan="1">Acciones</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let archivoGit of listaArchivosGralGuardada;">
                                                                <td class=" pt-0 pb-0" matTooltip="{{archivoGit.name}}"
                                                                    colspan="2">
                                                                    <img class="img" alt="icono archivo" height="34px"
                                                                        [src]="obtenerImagenTipoArchivo(archivoGit.type)">
                                                                    {{ archivoGit.name }}
                                                                </td>
                                                                <td class="text-center pt-1 pb-1 "
                                                                    matTooltip="Fecha de actualización">
                                                                    {{ archivoGit.fecha==null?'':archivoGit.fecha| date:
                                                                    'dd/MM/y, HH:mm' }}
                                                                </td>
                                                                <td class="text-center pt-0 pb-0" colspan="1">
                                                                    <button mat-raised-button
                                                                        class="btn btn-just-icon btn-link btn-icon-accions-file"
                                                                        (click)="consultarArchivoEstimacion(datosOportunidad.idGit, archivoGit.name, archivoGit.type)"
                                                                        matTooltip="Ver archivo">
                                                                        <i class="material-icons">visibility</i>
                                                                    </button>
                                                                    <button mat-raised-button
                                                                        class="btn btn-just-icon btn-link btn-icon-accions-file"
                                                                        (click)="descargaEvidencia(datosOportunidad.idGit, archivoGit.name, archivoGit.type)"
                                                                        matTooltip="Descargar archivo">
                                                                        <i class="material-icons">cloud_download</i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="row justify-content-end text-right">

                        <div class="col-lg-9 col-md-8 col-sm-12 d-grid d-md-flex gap-3 justify-content-md-end">
                            <button type="button" class="btn btn-sm " [ngClass]="[datosOportunidad.estado]"
                                (click)="agregarComentario('Comentario de líder', datosOportunidad)"
                                matTooltip="Agregar comentario">
                                <i class="material-icons">maps_ugc</i>&nbsp;&nbsp;Comentario</button>

                            <!-- <button type="button" class="btn btn-success btn-sm" matTooltip="Guardar estimación"
                                    (click)="guardarOportunidadDesarrollo()"  [disabled]="listaEstimacionAgregar.length==0" >
                                    <i class="material-icons">save</i>&nbsp;&nbsp;Guardar</button> -->

                            <button type="button" class="btn btn-success btn-sm" (click)="enviarOportunidadDesarrollo()"
                                matTooltip="Enviar a oficina de proyectos">
                                <i class="material-icons">send</i>&nbsp;&nbsp;Enviar</button>

                        </div>
                    </div>
                </div>

            </div>




        </div>
    </div>
</div>
<a class="download-zip-link" #downloadDocument aria-label="Descargar archivo"></a>